import React, { useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { UserContext } from "../contexts/userContext";
import CourseCard from "../components/CourseCard";
import { getUser, getUserCourse } from "../facades/UserFacade";
import Container from "@mui/material/Container";
import LinearProgress from "@mui/material/LinearProgress";
import ResultsCard from "../components/cards/ResultsCard";
import SchedulerCard from "../components/scheduler/SchedulerCard";
import useLiveLogging from "../hooks/useLiveLogging";
import { useTheme } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActionArea from "@mui/material/CardActionArea";
import LinearProgressWithLabel from "../components/LinearProgressWithLabel";
import scheduleLogo from "../assets/schedule.png";
import KeyDatesCard from "../components/cards/KeyDatesCard";
import KnowledgeBaseCard from "../components/cards/KnowledgeBaseCard";
import StudySkillsCard from "../components/cards/StudySkillsCard";
import CourseSummaryCard from "../components/cards/CourseSummaryCard";
import TimetableAndStudyPlanCard from "../components/cards/TimetableAndStudyPlanCard";
import FaqCard from "../components/cards/FaqCard";
import PledgeCard from "../components/cards/PledgeCard";
import ExamBookingCard from "../components/cards/ExamBookingCard";
import EasyAccessCardRow from "../components/dashboard/EasyAccessCardRow";
import DashboardSubjectRow from "../components/DashboardSubjectRow";
import { Helmet } from "react-helmet-async";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     flexGrow: 1,
//     paddingTop: theme.spacing(3),
//     paddingLeft: 0,
//     paddingRight: 0,
//     height: "100%",
//   },
//   progressBar: {
//     width: "100%",
//     "& > * + *": {
//       marginTop: theme.spacing(2),
//     },
//   },
// }));

export default function Dashboard() {
  const theme = useTheme();
  const userContext = useContext(UserContext);
  const [userCourseIds, setUserCoursesIds] = useState([]);
  const [study_essentials, setStudyEssentials] = useState();
  const [userCourses, setUserCourses] = useState([]);
  const [loadingPct, setLoadingPct] = useState(0);
  const loadingRef = React.createRef();
  loadingRef.current = loadingPct;
  const candidateAction = useLiveLogging();

  useEffect(() => {
    console.log("INITING");

    candidateAction({
      component: "Dashboard",
      event: "initialising Dashboard for user",
    });

    getUser(userContext.user)
      .then((response) => response.json())
      .then((userDetails) => {
        
        setUserCoursesIds(userDetails.courses);
        setStudyEssentials(userDetails.study_essentials)
      })
      .catch((error) => {
        candidateAction({
          component: "Dashboard",
          event: "Error loading user details for Dashboard",
          error: error,
        });
      });
  }, []);
  /*
  useEffect(() => {
    let courseDeets = [];
    userCourseIds.forEach((course) => {
      courseDeets.push(
        getUserCourse(course, userContext.user).then((x) => {
          loadingRef.current = loadingRef.current + 1;
          setLoadingPct(loadingRef.current); 
          return x;
        })
      );
    });

    Promise.all(courseDeets) //api call promise
      .then((r) => {
        return Promise.all(r.map((x) => x.json()));
      }) //resolve json content stream
      .then((c) => {
        // finally our data...
        c = c.filter((course) => course.code !== "not_found");
        setUserCourses(c);

        candidateAction({
          component: "Dashboard",
          event: "Dashboard initialized for user with courses",
          courses: c,
        });
      })
      .catch((error) => {
        candidateAction({
          component: "Dashboard",
          event: "Failed to obtain content to initialize dashboard",
          error: error,
        });
      });
  }, [userCourseIds]);
  */

  const makePanels = (courses) => {
    if (!courses) return;

    return courses.map(function (course, index) {
      /*  let completion = 0;
      if (course.user_course_details) {
        course.user_course_details.forEach((cd) => {
          if (cd.completed) {
            completion += 1;
          }
        });

        completion = (completion / course.user_course_details.length) * 100;
      }
      let rounded = +(Math.round(completion + "e+2") + "e-2");
*/
      return (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <CourseCard
            course={course.title}
            course_id={course.id}
            course_url={course.url_name}
            course_img={course.image}
          ></CourseCard>
        </Grid>
      );
    });
  };

  const getProgress = () => {
    return Math.round(
      (loadingRef.current /
        (userCourseIds.length == 0 ? 1 : userCourseIds.length)) *
        100
    );
  };

  return userCourseIds.length == 0 ? (
    <>
      <Helmet>
	<title>Dashboard - KnowledgEquity</title>
      </Helmet>
      <Box
	sx={{
          width: "100%",
          "& > * + *": {
            marginTop: theme.spacing(2),
          },
	}}
      >
	<LinearProgress color="primary" />

	<Grid
          container
          justifyContent="center"
          direction="column"
          alignItems="center"
	>
          <Grid item xs={12}>
            <Box sx={{ position: "relative", display: "inline-flex" }}>
              <CircularProgress variant="determinate" value={getProgress()} />
              <Box
		sx={{
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  position: "absolute",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
		}}
              >
		<Typography variant="caption" component="div" color="secondary">
                  {`${getProgress()}%`}
		</Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item>
            <Typography>One moment while we load your courses.</Typography>
          </Grid>
	</Grid>
      </Box>
    </>
  ) : (
    <Container maxWidth="xl">
      <Helmet>
	<title>Dashboard - KnowledgEquity</title>
      </Helmet>
      <Box
        sx={{
          flexGrow: 1,
          paddingTop: theme.spacing(3),
          paddingLeft: 0,
          paddingRight: 0,
          height: "100%",
          mb: 3,
          
        }}
      >
        <Stack spacing={3}>
          <EasyAccessCardRow userCourseIds={userCourseIds} studyEssentials={study_essentials}/>
          <Box>
            <Typography variant="h5" sx={{ mb: 1 }}>
              My Courses
            </Typography>
            <Paper
              elevation={0}
              sx={{
                "&.MuiPaper-elevation0": {
                  backgroundColor: theme.palette.grey[200],
                  borderRadius:5
                },
              }}
            >
              {
                userCourseIds.length > 0 ? userCourseIds.map(function (course, index)
                {
                  return (<DashboardSubjectRow course={course} key={index}/>)
                })
                :
                <Typography> You are not enrolled in any Courses. </Typography>
              }
              
            </Paper>
          </Box>
        </Stack>
      </Box>
    </Container>
  );
}

/*
 <Grid item xs={12} sm={6} md={4} key='schedule'>
            <SchedulerCard />
          </Grid>

*/
